/**
 * Created by Tiger on 03/03/2022.
 */

import React, {useEffect, useState} from 'react';
import CodeBlock from '../../common/code-block';
import HeadingBlock from '../../common/heading-block';
import Markdown from 'react-markdown/with-html';
import {connect} from 'react-redux';
import mapStateToProps from '../../redux/util';

function PlatformDocument(props) {
  const [markdown, setMarkdown] = useState('');
  useEffect(() => {
    const Data = props.locale.includes('en') ? props.markdownData.en : props.markdownData.zh;
    fetch(Data).then(res => res.text()).then(text => setMarkdown(text));
  }, [props.locale, props.markdownData]);
  return (<div>
    <Markdown source={ markdown } renderers={ { code: CodeBlock, heading: HeadingBlock } } escapeHtml={ false }/>
  </div>);
}

export default connect(mapStateToProps)(PlatformDocument);

